// core components
// admin pages
// // // // // admin dashboards
//import Dashboard from "views/admin/Dashboards/Dashboard.js";
import CREATEUSER from "views/admin/Dashboards/AddNewUser.js";
import DELETEUSER from "views/admin/Dashboards/DeleteAnyUser";
import DEACTIVEANYUSER from "views/admin/Dashboards/DeactivateAnyUser";
import ACTIVEANYUSER from "views/admin/Dashboards/ActivateAnyUser";
import CHANGEPASSWORD from "views/admin/Dashboards/ChangeUserPassword";
import CREATECOURSE from "views/admin/Dashboards/CreateNewCourse";
import CHANGEPASSWORDOWN from "views/admin/Dashboards/ChangePassword";
import BATCHFUNCTIONS from "views/admin/Dashboards/CreateNewBatch";
import ASSIGNEDCOURSES from "views/admin/Tables/YourBatch.js";
import ASSIGNEDCOURSESP from "views/admin/Tables/YourBatchPassive";
import ENROLLEDCOURSES from "views/admin/Tables/EnrolledBatch.js";
import ALLTEACHERS from "views/admin/Tables/ViewAllTeachers.js";
import ALLSTUDENTS from "views/admin/Tables/ViewAllStudents.js";
import ALLLOG from "views/admin/Tables/viewLogs.js";
import ALLCOURSES from "views/admin/Tables/ViewAllCourses.js";
import ENROLLEDCOURSESP from "views/admin/Tables/EnrolledBatchPassive";
import VIEWUPLOADFILE from "views/admin/Tables/ViewUploadFile";
import ADDCONTENT from "views/admin/Dashboards/AddContent";
import VIEWCONTENT from "views/admin/Dashboards/ViewCourseContent";
import ADDSESSIONLINK from "views/admin/Dashboards/AddSession.js";
import UPLOADFILE from "views/admin/Dashboards/UploadNewFile";
import VIEWSESSION from "views/admin/Tables/ViewSessionLink.js";
// // // // // admin examples
//import Timeline from "views/admin/Examples/Timeline.js";
//import Profile from "views/admin/Examples/Profile.js";
// // // // // admin components
//import Buttons from "views/admin/Components/Buttons.js";
//import Cards from "views/admin/Components/Cards.js";
//import Grid from "views/admin/Components/Grid.js";
//import Notifications from "views/admin/Components/Notifications.js";
//import Icons from "views/admin/Components/Icons.js";
//import Typography from "views/admin/Components/Typography.js";
// // // // // admin forms
//import Elements from "views/admin/Forms/Elements.js";
//import Components from "views/admin/Forms/Components.js";
//import Validation from "views/admin/Forms/Validation.js";
// // // // // admin tables

//import Sortable from "views/admin/Tables/Sortable.js";
//import ReactBSTable from "views/admin/Tables/ReactBSTable.js";

// rtl pages
//import RTL from "views/rtl/RTL.js";
// auth pages
//import Lock from "views/auth/Lock.js";
import Login from "views/auth/Login.js";
//import Pricing from "views/auth/Pricing.js";
//import Register from "views/auth/Register.js";
// @material-ui/icons components
//import BubbleChart from "@material-ui/icons/BubbleChart";
//import Dns from "@material-ui/icons/Dns";

import FlashOn from "@material-ui/icons/FlashOn";
import House from "@material-ui/icons/House";
import LockIcon from '@material-ui/icons/Lock';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Toc from "@material-ui/icons/Toc";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BuildIcon from '@material-ui/icons/Build';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import BlockIcon from '@material-ui/icons/Block';
//import { colors } from "@material-ui/core";

//import { colors } from "@material-ui/core";

var routes = [

  {
    path: "/Enrolled-Courses",
    name: "Enrolled Courses",
    miniName: "S",
    component: ENROLLEDCOURSES,
    layout: "/admin",
    iconColor:"orange",
    icon: ImportContactsIcon
  },

  {
    path: "/Enrolled-Courses-Passive",
    name: "Passive Courses",
    miniName: "S",
    component: ENROLLEDCOURSESP,
    layout: "/admin",
    icon: ImportContactsIcon
  },

  {
    path: "/Createuser",
        name: "Create User",
        miniName: "A",
        component: CREATEUSER,
        layout: "/admin",
        icon:PersonAddIcon

  },

  {
    path: "/Deleteuser",
    name: "Delete User",
    miniName: "A",
    component: DELETEUSER,
    layout: "/admin",
        icon:DeleteForeverIcon

  },

  {
    path: "/Deactivateuser",
    name: "Deactivate User",
    miniName: "A",
    component: DEACTIVEANYUSER,
    layout: "/admin",
        icon:BlockIcon

  },

  {
    path: "/Activateuser",
    name: "Activate User",
    miniName: "A",
    component: ACTIVEANYUSER,
    layout: "/admin",
        icon:CheckCircleIcon 

  },
  {
    path: "/Changeuserpassword",
    name: "Change password",
    miniName: "A",
    component: CHANGEPASSWORD,
    layout: "/admin",
    icon:VpnKeyIcon
  },

  {
    path: "/CreateCourse",
    name: "Create Course",
    miniName: "A",
    component: CREATECOURSE,
    layout: "/admin",
    icon:AddCircleIcon
  },



  {
    path: "/BatchFunctions",
    name: "Batch Functions",
    miniName: "A",
    component: BATCHFUNCTIONS,
    layout: "/admin",
    icon:BuildIcon
  },




  {
    path: "/AddContent",
    name: "Add Content",
    miniName: "X",
    component: ADDCONTENT,
    layout: "/admin",
    icon:House
  },

  {
    path: "/ViewContent",
    name: "View Content",
    miniName: "X",
    component: VIEWCONTENT,
    layout: "/admin",
    icon:House
  },


  {
    path: "/ViewSession",
    name: "View Session",
    miniName: "X",
    component: VIEWSESSION,
    layout: "/admin",
    icon:House
  },

  {
    path: "/AddSession",
    name: "Add session",
    miniName: "X",
    component: ADDSESSIONLINK,
    layout: "/admin",
    icon:House
  },


  {
    path: "/UploadFile",
    name: "UploadFile",
    miniName: "X",
    component: UPLOADFILE,
    layout: "/admin",
    icon:House
  },

  
  {
    path: "/ViewUploadFile",
    name: "UploadFiles",
    miniName: "X",
    component: VIEWUPLOADFILE,
    layout: "/admin",
    icon:House
  },

   {
    path: "/All-Teachers",
    name: "All Teachers",
    miniName: "A",
    component: ALLTEACHERS,
    layout: "/admin",
    icon: ImportContactsIcon
  },

  {
    path: "/All-Students",
    name: "All Students",
    miniName: "A",
    component: ALLSTUDENTS,
    layout: "/admin",
    icon: ImportContactsIcon
  },

  {
    path: "/View-Logs",
    name: "View Logs",
    miniName: "A",
    component: ALLLOG,
    layout: "/admin",
    icon: ImportContactsIcon
  },


  {
    path: "/All-Courses",
    name: "All Batches",
    miniName: "A",
    component: ALLCOURSES,
    layout: "/admin",
    icon: ImportContactsIcon
  },
  {
    path: "/Assigned-Courses",
    name: "My Courses",
    miniName: "T",
    component: ASSIGNEDCOURSES,
    layout: "/admin",
    icon: ImportContactsIcon
  },

  {
    path: "/Assigned-Courses-passive",
    name: "Passive Courses",
    miniName: "T",
    component: ASSIGNEDCOURSESP,
    layout: "/admin",
    icon: ImportContactsIcon
  },


  {
    path: "/ChangePassword",
    name: "Edit Password",
    miniName: "ts",
    component: CHANGEPASSWORDOWN,
    layout: "/admin",
    icon:VpnKeyIcon
  },

  

  {
    path: "/login",
    name: "Logout",
    miniName: "ts",
    component: Login,
    layout: "/auth",
    icon:LockIcon,
    color:"#092157"
  },
  

  
  {
    divider: true,
  },
  {
    href: "https://thelanofficial.com/",
    name: "Visit us",
    icon: House,
   
  },
  {
    href: "https://thelanofficial.com/about-us-2/",
    name: "About us",
    icon: FlashOn,
    
  },
  {
    collapse: true,
    name: "Courses",
    icon: Toc,
   
    views: [
      {
        href: "https://thelanofficial.com/courses/",
        name: "View all",
      },
      {
        href: "https://thelanofficial.com/course-category/aws/?tutor-course-filter-category=360",
        name: "AWS",
      },
      {
        href: "https://thelanofficial.com/course-category/aws/?tutor-course-filter-category=361",
        name: "Cisco",
      },
      {
        href: "https://thelanofficial.com/course-category/microsoft/?tutor-course-filter-category=362",
        name: "Microsoft",
      },
      {
        href: "https://thelanofficial.com/course-category/comptiaa/?tutor-course-filter-category=363",
        name: "CompatiaA",
      },
      {
        href: "https://thelanofficial.com/course-category/ec-council/?tutor-course-filter-category=364",
        name: "EC-COUNCIL",
      },
      {
        href: "https://thelanofficial.com/course-category/isaca/?tutor-course-filter-category=366",
        name: "ISACA",
      },
      {
        href: "https://thelanofficial.com/course-category/isc2/?tutor-course-filter-category=365",
        name: "ISC2",
      },
    ],
  },

  
];
export default routes;
